import React, { useContext } from "react";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import XLabelField from "component/labelField/XLabelField";
import t from "module/translations";

const MaintenanceTaskReportingNumberFieldContainer: React.FC = () => {
  const { entity } = useContext(MaintenanceTaskContext);
  const { reportingNumber } = entity as MaintenanceTaskInterface;

  return (
    <XLabelField
      {...{
        caption: t.maintenanceTask.reportingNumberText,
        label: reportingNumber,
      }}
    />
  );
};

export default React.memo(MaintenanceTaskReportingNumberFieldContainer);
